import { useEffect, useState } from 'react';
import FormControlSelect from '../../../../../components/molecules/FormControl/FormControlSelect';
import { beautify } from '../../../../../helpers/str';
import { transform } from '../../../../../helpers/transform';
import { updateObject } from '../../../../../helpers/obj';

const NodePermissions = ({ config, onChange }) => {
    const [permissions, setPermissions] = useState(config);
    const [selectedRow, setSelectedRow] = useState(0);

    const handleAdd = () => {
        const newPermissions = [...permissions];
        newPermissions.push({
            roles: [],
            actions: [],
        });
        updatePermissions(newPermissions);
    };

    const handleUpdate = (index, name, options) => {
        const newPermissions = [...permissions];
        const values = options.map((row) => row.value);
        newPermissions[index] = updateObject(newPermissions[index], name, values);
        updatePermissions(newPermissions);
    };

    const handleDelete = () => {};

    const updatePermissions = (newPermissions) => {
        setPermissions(newPermissions);
        if (onChange) {
            onChange(newPermissions);
        }
    };

    useEffect(() => {
        if (config) {
            setPermissions(config);
        }
    }, [config]);
    return (
        <>
            {permissions?.map((row, index) => {
                return (
                    <div
                        className='panel__section p-5'
                        key={index}>
                        <div className='d-flex align-items-center justify-content-between'>
                            <div className='d-flex align-items-center'>
                                <i
                                    className={`bi bi-shield-fill-check me-1 ${
                                        selectedRow === index ? 'text-info' : ''
                                    }`}></i>
                                <h5
                                    onClick={() =>
                                        selectedRow === index
                                            ? setSelectedRow('')
                                            : setSelectedRow(index)
                                    }
                                    className='fs-8 p-0 m-0 cursor-pointer'>
                                    Permission {index + 1}
                                </h5>
                            </div>
                            <div>
                                <span
                                    className='cursor-pointer ms-2'
                                    onClick={() => handleDelete(index)}>
                                    <i className='bi bi-dash-circle-fill text-danger'></i>
                                </span>
                                <span
                                    className='cursor-pointer ms-2'
                                    onClick={() => setSelectedRow(index)}>
                                    <i
                                        className={`bi bi-chevron-${
                                            selectedRow === index ? 'up' : 'down'
                                        }`}></i>
                                </span>
                            </div>
                        </div>
                        {selectedRow === index && (
                            <div className='mt-5'>
                                {['roles', 'actions'].map((item) => {
                                    return (
                                        <div className='mb-5'>
                                            <h5 className='fs-8 cursor-pointer'>
                                                {beautify(item)}
                                            </h5>
                                            <FormControlSelect
                                                value={row[item] || []}
                                                item={{
                                                    name: 'template_id',
                                                    options: row[item]
                                                        ? transform(
                                                              'options',
                                                              permissions?.[index]?.[item]
                                                          )
                                                        : [],
                                                    multi: true,
                                                    creatable: true,
                                                }}
                                                onSelectChange={(name, option) =>
                                                    handleUpdate(index, item, option)
                                                }
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                );
            })}
            <div
                className='d-flex justify-content-center mt-5'
                onClick={handleAdd}>
                <button className='btn btn-sm btn-icon btn-circle btn-dark'>
                    <i className='bi bi-plus-lg'></i>
                </button>
            </div>
        </>
    );
};
export default NodePermissions;
